'use client';

import * as React from 'react';
import {CategoryButton} from '@purpose/ui/components/CategoryButton';
import {cn} from '@purpose/ui/lib/utils';

interface CategoryButtonsGridProps {
  typesProps: {
    name: string;
    id: number;
    icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  }[];
  onClick?: (id: number) => () => void;
  className?: string;
  buttonSx?: any;
  buttonClassName?: string;
  containerClassName?: string;
}

const CategoryButtonsGrid = React.forwardRef<
  HTMLDivElement,
  CategoryButtonsGridProps
>(
  (
    {
      typesProps,
      onClick,
      className,
      buttonSx,
      buttonClassName,
      containerClassName
    },
    ref
  ) => {
    if (!typesProps) return null;
    return (
      <div ref={ref} className={cn('max-w-full', className)}>
        {/* Mobile version */}
        <div
          className={cn(
            'my-0.5 flex w-full gap-3 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] md:hidden [&::-webkit-scrollbar]:hidden',
            containerClassName
          )}
        >
          {typesProps.map((typeButton, index) => (
            <CategoryButton
              key={typeButton.id}
              onClick={onClick?.(typeButton.id) || undefined}
              name={typeButton.name}
              Icon={typeButton.icon}
              className={cn(
                `h-[100px] w-[150px] flex-shrink-0 ${index === typesProps.length - 1 ? 'mr-4' : ''}`,
                buttonClassName
              )}
              sx={buttonSx}
            />
          ))}
        </div>

        {/* Desktop version */}
        <div
          className={cn('hidden gap-4 px-8 md:grid', containerClassName)}
          style={{
            gridTemplateColumns: `repeat(${typesProps?.length || 7}, minmax(0, 1fr))`
          }}
        >
          {typesProps.map(typeButton => (
            <CategoryButton
              key={typeButton.id}
              onClick={onClick?.(typeButton.id) || undefined}
              name={typeButton.name}
              Icon={typeButton.icon}
              sx={buttonSx}
              className={buttonClassName}
            />
          ))}
        </div>
      </div>
    );
  }
);

CategoryButtonsGrid.displayName = 'CategoryButtonsGrid';

export {CategoryButtonsGrid};
export type {CategoryButtonsGridProps};
